
    import { Component } from 'vue-property-decorator';
    import Navigation from '@/components/Navigation/Navigation.vue';
    import { MenuDivider, MenuItem } from '@/components/Navigation/Menu';
    import { mapGetters } from 'vuex';

    export type SearchItem = {
        name: string;
        menu: MenuItem;
    };

    @Component({
        computed: {
            ...mapGetters('authentication', ['isAllowed']),
        },
    })
    export default class NavigationPalette extends Navigation {
        public search: string | null = null;
        public selected: SearchItem | null = null;
        public visible = false;

        public get items(): SearchItem[] {
            return this.menu
                .map((item) => {
                    if (item.children?.length) {
                        return item.children
                            .filter((child) => !(child as MenuDivider).divider)
                            .map((child) => {
                                const item = child as MenuItem;
                                return {
                                    name: item.label,
                                    menu: child as MenuItem,
                                };
                            });
                    } else {
                        return {
                            name: item.label,
                            menu: item,
                        };
                    }
                })
                .flat()
                .filter(({ menu }) => {
                    return (!menu.permissions || this.isAllowed(...menu.permissions)) && (!menu.show || menu.show());
                })
                .sort((a, b) => a.name.localeCompare(b.name));
        }

        public mounted(): void {
            document.addEventListener('keyup', this.onKeyUp);
        }

        public destroy(): void {
            document.removeEventListener('keyup', this.onKeyUp);
        }

        public splitNameBySearch(name: string, part: 1 | 2 | 3): string {
            if (this.search) {
                const index = name.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase());
                if (index !== -1) {
                    switch (part) {
                        case 1:
                            return name.substring(0, index);
                        case 2:
                            return name.substring(index, index + this.search.length);
                        case 3:
                            return name.substring(index + this.search.length);
                    }
                }
            }
            return part === 1 ? name : '';
        }

        public onKeyUp(event: KeyboardEvent): void {
            if (event.ctrlKey && event.shiftKey && event.key === 'F') {
                this.visible = !this.visible;

                if (this.visible) {
                    this.selected = null;
                }
            }
        }

        public onClickEnter(): void {
            if (this.selected) {
                if (this.selected.menu.goto) {
                    this.goto(this.selected.menu.goto);
                } else if (this.selected.menu.action) {
                    this.selected.menu.action(this);
                }

                this.visible = false;
            }
        }
    }
